import * as ReactRouter from "react-router";
import { connect } from "react-redux";
import View from "./View";
import { RootState } from "src/ipm-shared/store/model/reducers";
import * as selectors from "src/bepaid/store/model/Fetch/selectors";
import * as actions from "src/bepaid/store/model/Fetch/actions";

const mapStateToProps = (state: RootState, props: any) => ({
  extraInfo: selectors.getExtraInfo(state, props.modalId)
});

const mapDispatchToProps = {
  toggleModal: actions.toggleModal,
  changeUserSetting: actions.changeUserSetting
};

export type IProps = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps &
  ReactRouter.RouteProps;

export default connect(mapStateToProps, mapDispatchToProps)(View);
